import canvasGrid from './canvas/canvas-grid.svg'
import smartSelect from './canvas/smart-select.svg'
import bpIdentifierChecked from './device-tree/bp-identifier-checked.svg'
import bpIdentifier from './device-tree/bp-identifier.svg'
import deviceNavChecked from './device-tree/device-nav-checked.svg'
import deviceNav from './device-tree/device-nav.svg'
import electricCableSet from './device-tree/electric-cable-set.svg'
import electricCable from './device-tree/electric-cable.svg'
import featureSet from './device-tree/feature-set.svg'
import featureUnset from './device-tree/feature-unset.svg'
import plcTreeBox from './device-tree/plc-tree-box.svg'
import shieldInsert from './device-tree/shield-insert.svg'
import treeConnection from './device-tree/tree-connection.svg'
import adjustCanvas from './files/adjust-canvas.svg'
import arcByPoints from './files/arc-by-points.svg'
import arc from './files/arc.svg'
import bpLeft from './files/bp-left.svg'
import bpMarkLetter from './files/bp-mark-letter.svg'
import bpRight from './files/bp-right.svg'
import bpView from './files/bp-view.svg'
import bpView2 from './files/bp-view2.svg'
import cadFile from './files/cad-file.svg'
import catchGrid from './files/catch-grid.svg'
import catchSymbol from './files/catch-symbol.svg'
import circleByPoints from './files/circle-by-points.svg'
import circle from './files/circle.svg'
import colText from './files/col-text.svg'
import collect from './files/collect.svg'
import config from './files/config.svg'
import curve from './files/curve.svg'
import device from './files/device.svg'
import down from './files/down.svg'
import drawings from './files/drawings.svg'
import dynamicText from './files/dynamic-text.svg'
import ellipse from './files/ellipse.svg'
import exitFullscreen from './files/exit-fullscreen.svg'
import export1 from './files/export1.svg'
import fitScreen from './files/fit-screen.svg'
import intoFullscreen from './files/into-fullscreen.svg'
import lastPage from './files/last-page.svg'
import leftTriangle from './files/left-triangle.svg'
import line from './files/line.svg'
import line2 from './files/line2.svg'
import link from './files/link.svg'
import logic from './files/logic.svg'
import macro from './files/macro.svg'
import menuGraphics from './files/menu-graphics.svg'
import minus from './files/minus.svg'
import mountingPlate from './files/mounting-plate.svg'
import nextPage from './files/next-page.svg'
import pictureFrame from './files/picture-frame.svg'
import picture from './files/picture.svg'
import pinDown from './files/pin-down.svg'
import pinLeft from './files/pin-left.svg'
import pinRight from './files/pin-right.svg'
import pinUp from './files/pin-up.svg'
import pinned from './files/pinned.svg'
import plus from './files/plus.svg'
import polygon from './files/polygon.svg'
import polyline from './files/polyline.svg'
import project from './files/project.svg'
import qrCode from './files/qr-code.svg'
import recent from './files/recent.svg'
import rectByPoints from './files/rect-by-points.svg'
import rect from './files/rect.svg'
import redo from './files/redo.svg'
import rightTriangle from './files/right-triangle.svg'
import rowText from './files/row-text.svg'
import save from './files/save.svg'
import search from './files/search.svg'
import sector from './files/sector.svg'
import share from './files/share.svg'
import shopCart from './files/shop-cart.svg'
import showDistance from './files/show-distance.svg'
import showHiddenTexts from './files/show-hidden-texts.svg'
import symbol from './files/symbol.svg'
import table from './files/table.svg'
import template from './files/template.svg'
import text from './files/text.svg'
import toDesign from './files/to-design.svg'
import toView from './files/to-view.svg'
import undo from './files/undo.svg'
import user from './files/user.svg'
import acbp from './graphs/acbp.svg'
import breakPoint from './graphs/break-point.svg'
import crossJoint from './graphs/cross-joint.svg'
import diagonal from './graphs/diagonal.svg'
import higherLeftCorner from './graphs/higher-left-corner.svg'
import higherRightCorner from './graphs/higher-right-corner.svg'
import jumper from './graphs/jumper.svg'
import lowerLeftCorner from './graphs/lower-left-corner.svg'
import lowerRightCorner from './graphs/lower-right-corner.svg'
import tDown from './graphs/t-down.svg'
import tLeft from './graphs/t-left.svg'
import tRight from './graphs/t-right.svg'
import tUp from './graphs/t-up.svg'
import anquanwuyou from './home/anquanwuyou.svg'
import baozhang from './home/baozhang.svg'
import dingzhi from './home/dingzhi.svg'
import partsTreeSwitcher from './home/parts-tree-switcher.svg'
import wufengjicheng from './home/wufengjicheng.svg'
import xingneng from './home/xingneng.svg'
import zizhukekong from './home/zizhukekong.svg'
import addCdp from './menu/add-cdp.svg'
import alignCenter from './menu/align-center.svg'
import alignLeft from './menu/align-left.svg'
import alignRight from './menu/align-right.svg'
import analogInput from './menu/analog-input.svg'
import analogOutput from './menu/analog-output.svg'
import anchorBottom from './menu/anchor-bottom.svg'
import anchorMiddle from './menu/anchor-middle.svg'
import anchorTop from './menu/anchor-top.svg'
import autoCode from './menu/auto-code.svg'
import autoWrap from './menu/auto-wrap.svg'
import back from './menu/back.svg'
import blackBox from './menu/black-box.svg'
import bold from './menu/bold.svg'
import borderRadius from './menu/border-radius.svg'
import bottomLayer from './menu/bottom-layer.svg'
import boxInsert from './menu/box-insert.svg'
import busPort from './menu/bus-port.svg'
import busbarConnectionPoint from './menu/busbar-connection-point.svg'
import busbarDefPoint from './menu/busbar-def-point.svg'
import cableHarness from './menu/cable-harness.svg'
import cable from './menu/cable.svg'
import cardPower from './menu/card-power.svg'
import chamfer from './menu/chamfer.svg'
import cmClose from './menu/cm-close.svg'
import cmCopy from './menu/cm-copy.svg'
import cmCreatePage from './menu/cm-create-page.svg'
import cmCreateProject from './menu/cm-create-project.svg'
import cmDelete from './menu/cm-delete.svg'
import cmEdit from './menu/cm-edit.svg'
import cmExport from './menu/cm-export.svg'
import cmMove from './menu/cm-move.svg'
import cmOpen from './menu/cm-open.svg'
import cmPermission from './menu/cm-permission.svg'
import cmProperty from './menu/cm-property.svg'
import cmRename from './menu/cm-rename.svg'
import cmShare from './menu/cm-share.svg'
import cmStart from './menu/cm-start.svg'
import codingCdp from './menu/coding-cdp.svg'
import connectionInsert from './menu/connection-insert.svg'
import connectionPointPower from './menu/connection-point-power.svg'
import copy from './menu/copy.svg'
import cost from './menu/cost.svg'
import crossLink from './menu/cross-link.svg'
import crst from './menu/crst.svg'
import cut from './menu/cut.svg'
import datasetAttr from './menu/dataset-attr.svg'
import designMode from './menu/design-mode.svg'
import deviceAttr from './menu/device-attr.svg'
import deviceCodingSetting from './menu/device-coding-setting.svg'
import deviceCoding from './menu/device-coding.svg'
import deviceConnectionPointsBoth from './menu/device-connection-points-both.svg'
import deviceConnectionPoints from './menu/device-connection-points.svg'
import deviceList from './menu/device-list.svg'
import digitalInput from './menu/digital-input.svg'
import digitalOutput from './menu/digital-output.svg'
import distributedTerminals from './menu/distributed-terminals.svg'
import editDirectly from './menu/edit-directly.svg'
import electricityTerminal from './menu/electricity-terminal.svg'
import fillColor from './menu/fill-color.svg'
import fixed from './menu/fixed.svg'
import flipVertical from './menu/flip-vertical.svg'
import flip from './menu/flip.svg'
import fontColor from './menu/font-color.svg'
import font from './menu/font.svg'
import formatBrush from './menu/format-brush.svg'
import group from './menu/group.svg'
import groupedAttributes from './menu/grouped-attributes.svg'
import historyVersion from './menu/history-version.svg'
import horizontalBottom from './menu/horizontal-bottom.svg'
import horizontalCenter from './menu/horizontal-center.svg'
import horizontalDistribution from './menu/horizontal-distribution.svg'
import horizontalTop from './menu/horizontal-top.svg'
import insertionPoint from './menu/insertion-point.svg'
import italic from './menu/italic.svg'
import layoutSymbol from './menu/layout-symbol.svg'
import lineColor from './menu/line-color.svg'
import lineHeight from './menu/line-height.svg'
import lineStyle from './menu/line-style.svg'
import lineWidth from './menu/line-width.svg'
import logout from './menu/logout.svg'
import materialList from './menu/material-list.svg'
import multiCopy from './menu/multi-copy.svg'
import networkDef from './menu/network-def.svg'
import openPageInNewTab from './menu/open-page-in-new-tab.svg'
import pageAttr from './menu/page-attr.svg'
import partsAttributes from './menu/parts-attributes.svg'
import paste from './menu/paste.svg'
import pathText from './menu/path-text.svg'
import path from './menu/path.svg'
import phaseBus from './menu/phase-bus.svg'
import pictureSymbol from './menu/picture-symbol.svg'
import pinInsert from './menu/pin-insert.svg'
import plc from './menu/plc.svg'
import plugDef from './menu/plug-def.svg'
import plug from './menu/plug.svg'
import potentialConnection from './menu/potential-connection.svg'
import potentialDef from './menu/potential-def.svg'
import potential from './menu/potential.svg'
import projectAttr from './menu/project-attr.svg'
import projectStructure from './menu/project-structure.svg'
import propertySettings from './menu/property-settings.svg'
import pruning from './menu/pruning.svg'
import rowWrap from './menu/row-wrap.svg'
import scale from './menu/scale.svg'
import setting from './menu/setting.svg'
import slst from './menu/slst.svg'
import structureBox from './menu/structure-box.svg'
import structure from './menu/structure.svg'
import tableEdit from './menu/table-edit.svg'
import terminalStripDef from './menu/terminal-strip-def.svg'
import terminal from './menu/terminal.svg'
import toolCheck from './menu/tool-check.svg'
import toolCodeSetting from './menu/tool-code-setting.svg'
import toolCrossUp from './menu/tool-cross-up.svg'
import toolGenerateTable from './menu/tool-generate-table.svg'
import toolNotification from './menu/tool-notification.svg'
import toolPotentialTrack from './menu/tool-potential-track.svg'
import toolSignal from './menu/tool-signal.svg'
import toolSyncTable from './menu/tool-sync-table.svg'
import toolSync from './menu/tool-sync.svg'
import toolUpdate from './menu/tool-update.svg'
import toolbarBreakPoint from './menu/toolbar-break-point.svg'
import toolbarDevice from './menu/toolbar-device.svg'
import toolbarLink from './menu/toolbar-link.svg'
import toolbarMacro from './menu/toolbar-macro.svg'
import toolbarPictureFrame from './menu/toolbar-picture-frame.svg'
import toolbarPreview from './menu/toolbar-preview.svg'
import toolbarSymbol from './menu/toolbar-symbol.svg'
import topLayer from './menu/top-layer.svg'
import ts from './menu/ts.svg'
import tst from './menu/tst.svg'
import underline from './menu/underline.svg'
import ungroup from './menu/ungroup.svg'
import updateConnection from './menu/update-connection.svg'
import updateProjectFrame from './menu/update-project-frame.svg'
import updateProjectMacro from './menu/update-project-macro.svg'
import updateProjectParts from './menu/update-project-parts.svg'
import updateProjectSymbol from './menu/update-project-symbol.svg'
import updateProjectTableTemplate from './menu/update-project-table-template.svg'
import verticalCenter from './menu/vertical-center.svg'
import verticalDistribution from './menu/vertical-distribution.svg'
import verticalLeft from './menu/vertical-left.svg'
import verticalRight from './menu/vertical-right.svg'
import downloadList from './parts/download-list.svg'
import nodeClose from './parts/node-close.svg'
import nodeOpen from './parts/node-open.svg'
import resourceList from './parts/resource-list.svg'
import symbolTreeL4 from './parts/symbol-tree-l4.svg'
import symbolTreeL5 from './parts/symbol-tree-l5.svg'
import symbolTreeL6 from './parts/symbol-tree-l6.svg'
import BRA from './symbols/BR-A.svg'
import BRB from './symbols/BR-B.svg'
import BRC from './symbols/BR-C.svg'
import BRD from './symbols/BR-D.svg'
import CRA from './symbols/CR-A.svg'
import CRB from './symbols/CR-B.svg'
import CRC from './symbols/CR-C.svg'
import CRD from './symbols/CR-D.svg'
import LBRA from './symbols/LBR-A.svg'
import LBRB from './symbols/LBR-B.svg'
import LBRLA from './symbols/LBRL-A.svg'
import LBRLB from './symbols/LBRL-B.svg'
import LBRLC from './symbols/LBRL-C.svg'
import LBRLD from './symbols/LBRL-D.svg'
import TLROA from './symbols/TLRO-A.svg'
import TLROB from './symbols/TLRO-B.svg'
import TLROC from './symbols/TLRO-C.svg'
import TLROD from './symbols/TLRO-D.svg'
import TLRUA from './symbols/TLRU-A.svg'
import TLRUB from './symbols/TLRU-B.svg'
import TLRUC from './symbols/TLRU-C.svg'
import TLRUD from './symbols/TLRU-D.svg'
import TOULA from './symbols/TOUL-A.svg'
import TOULB from './symbols/TOUL-B.svg'
import TOULC from './symbols/TOUL-C.svg'
import TOULD from './symbols/TOUL-D.svg'
import TOURA from './symbols/TOUR-A.svg'
import TOURB from './symbols/TOUR-B.svg'
import TOURC from './symbols/TOUR-C.svg'
import TOURD from './symbols/TOUR-D.svg'
import tabDrawPlatform from './tabs/tab-draw-platform.svg'
import tabDraw from './tabs/tab-draw.svg'
import tabFramePlatform from './tabs/tab-frame-platform.svg'
import tabFrame from './tabs/tab-frame.svg'
import tabMacroPlatform from './tabs/tab-macro-platform.svg'
import tabMacro from './tabs/tab-macro.svg'
import tabSymbolPlatform from './tabs/tab-symbol-platform.svg'
import tabSymbol from './tabs/tab-symbol.svg'
import tabTablePlatform from './tabs/tab-table-platform.svg'
import tabTable from './tabs/tab-table.svg'
import add from './ui/add.svg'
import alignGrid from './ui/align-grid.svg'
import alignmark from './ui/alignmark.svg'
import angelmark from './ui/angelmark.svg'
import baselinemark from './ui/baselinemark.svg'
import cableNav from './ui/cable-nav.svg'
import continuousmark from './ui/continuousmark.svg'
import deviceListNav from './ui/device-list-nav.svg'
import dockDisabled from './ui/dock-disabled.svg'
import docked from './ui/docked.svg'
import dockingDown from './ui/docking-down.svg'
import dockingLeft from './ui/docking-left.svg'
import dockingRight from './ui/docking-right.svg'
import dockingUp from './ui/docking-up.svg'
import empty from './ui/empty.svg'
import fileDefault from './ui/file-default.svg'
import fileJpg from './ui/file-jpg.svg'
import filePdf from './ui/file-pdf.svg'
import filePng from './ui/file-png.svg'
import graphPage from './ui/graph-page.svg'
import home from './ui/home.svg'
import incrementmark from './ui/incrementmark.svg'
import layoutPage from './ui/layout-page.svg'
import linemark from './ui/linemark.svg'
import linkNav from './ui/link-nav.svg'
import linkPointInCabdl from './ui/link-point-in-cabdl.svg'
import macroVariant from './ui/macro-variant.svg'
import macroVariant2 from './ui/macro-variant2.svg'
import macroVariant3 from './ui/macro-variant3.svg'
import macroVariant4 from './ui/macro-variant4.svg'
import more from './ui/more.svg'
import overviewPage from './ui/overview-page.svg'
import page from './ui/page.svg'
import panView from './ui/pan-view.svg'
import pinInsertNav from './ui/pin-insert-nav.svg'
import plugNav from './ui/plug-nav.svg'
import plusOutline from './ui/plus-outline.svg'
import potentialNav from './ui/potential-nav.svg'
import potetialTree from './ui/potetial-tree.svg'
import radiusmark from './ui/radiusmark.svg'
import remove from './ui/remove.svg'
import structureAnd from './ui/structure-and.svg'
import structureDbis from './ui/structure-dbis.svg'
import structureDbplus from './ui/structure-dbplus.svg'
import structureIs from './ui/structure-is.svg'
import structurePlus from './ui/structure-plus.svg'
import structureUser from './ui/structure-user.svg'
import symbolLibEnterprise from './ui/symbol-lib-enterprise.svg'
import symbolLibPlatform from './ui/symbol-lib-platform.svg'
import tablePage from './ui/table-page.svg'
import terminalNav from './ui/terminal-nav.svg'
import topologyPage from './ui/topology-page.svg'
import treePlug from './ui/tree-plug.svg'
import treePotential from './ui/tree-potential.svg'
import treeTerminal from './ui/tree-terminal.svg'
import undocked from './ui/undocked.svg'

export default {
  canvasGrid,
  smartSelect,
  bpIdentifierChecked,
  bpIdentifier,
  deviceNavChecked,
  deviceNav,
  electricCableSet,
  electricCable,
  featureSet,
  featureUnset,
  plcTreeBox,
  shieldInsert,
  treeConnection,
  adjustCanvas,
  arcByPoints,
  arc,
  bpLeft,
  bpMarkLetter,
  bpRight,
  bpView,
  bpView2,
  cadFile,
  catchGrid,
  catchSymbol,
  circleByPoints,
  circle,
  colText,
  collect,
  config,
  curve,
  device,
  down,
  drawings,
  dynamicText,
  ellipse,
  exitFullscreen,
  export1,
  fitScreen,
  intoFullscreen,
  lastPage,
  leftTriangle,
  line,
  line2,
  link,
  logic,
  macro,
  menuGraphics,
  minus,
  mountingPlate,
  nextPage,
  pictureFrame,
  picture,
  pinDown,
  pinLeft,
  pinRight,
  pinUp,
  pinned,
  plus,
  polygon,
  polyline,
  project,
  qrCode,
  recent,
  rectByPoints,
  rect,
  redo,
  rightTriangle,
  rowText,
  save,
  search,
  sector,
  share,
  shopCart,
  showDistance,
  showHiddenTexts,
  symbol,
  table,
  template,
  text,
  toDesign,
  toView,
  undo,
  user,
  acbp,
  breakPoint,
  crossJoint,
  diagonal,
  higherLeftCorner,
  higherRightCorner,
  jumper,
  lowerLeftCorner,
  lowerRightCorner,
  tDown,
  tLeft,
  tRight,
  tUp,
  anquanwuyou,
  baozhang,
  dingzhi,
  partsTreeSwitcher,
  wufengjicheng,
  xingneng,
  zizhukekong,
  addCdp,
  alignCenter,
  alignLeft,
  alignRight,
  analogInput,
  analogOutput,
  anchorBottom,
  anchorMiddle,
  anchorTop,
  autoCode,
  autoWrap,
  back,
  blackBox,
  bold,
  borderRadius,
  bottomLayer,
  boxInsert,
  busPort,
  busbarConnectionPoint,
  busbarDefPoint,
  cableHarness,
  cable,
  cardPower,
  chamfer,
  cmClose,
  cmCopy,
  cmCreatePage,
  cmCreateProject,
  cmDelete,
  cmEdit,
  cmExport,
  cmMove,
  cmOpen,
  cmPermission,
  cmProperty,
  cmRename,
  cmShare,
  cmStart,
  codingCdp,
  connectionInsert,
  connectionPointPower,
  copy,
  cost,
  crossLink,
  crst,
  cut,
  datasetAttr,
  designMode,
  deviceAttr,
  deviceCodingSetting,
  deviceCoding,
  deviceConnectionPointsBoth,
  deviceConnectionPoints,
  deviceList,
  digitalInput,
  digitalOutput,
  distributedTerminals,
  editDirectly,
  electricityTerminal,
  fillColor,
  fixed,
  flipVertical,
  flip,
  fontColor,
  font,
  formatBrush,
  group,
  groupedAttributes,
  historyVersion,
  horizontalBottom,
  horizontalCenter,
  horizontalDistribution,
  horizontalTop,
  insertionPoint,
  italic,
  layoutSymbol,
  lineColor,
  lineHeight,
  lineStyle,
  lineWidth,
  logout,
  materialList,
  multiCopy,
  networkDef,
  openPageInNewTab,
  pageAttr,
  partsAttributes,
  paste,
  pathText,
  path,
  phaseBus,
  pictureSymbol,
  pinInsert,
  plc,
  plugDef,
  plug,
  potentialConnection,
  potentialDef,
  potential,
  projectAttr,
  projectStructure,
  propertySettings,
  pruning,
  rowWrap,
  scale,
  setting,
  slst,
  structureBox,
  structure,
  tableEdit,
  terminalStripDef,
  terminal,
  toolCheck,
  toolCodeSetting,
  toolCrossUp,
  toolGenerateTable,
  toolNotification,
  toolPotentialTrack,
  toolSignal,
  toolSyncTable,
  toolSync,
  toolUpdate,
  toolbarBreakPoint,
  toolbarDevice,
  toolbarLink,
  toolbarMacro,
  toolbarPictureFrame,
  toolbarPreview,
  toolbarSymbol,
  topLayer,
  ts,
  tst,
  underline,
  ungroup,
  updateConnection,
  updateProjectFrame,
  updateProjectMacro,
  updateProjectParts,
  updateProjectSymbol,
  updateProjectTableTemplate,
  verticalCenter,
  verticalDistribution,
  verticalLeft,
  verticalRight,
  downloadList,
  nodeClose,
  nodeOpen,
  resourceList,
  symbolTreeL4,
  symbolTreeL5,
  symbolTreeL6,
  BRA,
  BRB,
  BRC,
  BRD,
  CRA,
  CRB,
  CRC,
  CRD,
  LBRA,
  LBRB,
  LBRLA,
  LBRLB,
  LBRLC,
  LBRLD,
  TLROA,
  TLROB,
  TLROC,
  TLROD,
  TLRUA,
  TLRUB,
  TLRUC,
  TLRUD,
  TOULA,
  TOULB,
  TOULC,
  TOULD,
  TOURA,
  TOURB,
  TOURC,
  TOURD,
  tabDrawPlatform,
  tabDraw,
  tabFramePlatform,
  tabFrame,
  tabMacroPlatform,
  tabMacro,
  tabSymbolPlatform,
  tabSymbol,
  tabTablePlatform,
  tabTable,
  add,
  alignGrid,
  alignmark,
  angelmark,
  baselinemark,
  cableNav,
  continuousmark,
  deviceListNav,
  dockDisabled,
  docked,
  dockingDown,
  dockingLeft,
  dockingRight,
  dockingUp,
  empty,
  fileDefault,
  fileJpg,
  filePdf,
  filePng,
  graphPage,
  home,
  incrementmark,
  layoutPage,
  linemark,
  linkNav,
  linkPointInCabdl,
  macroVariant,
  macroVariant2,
  macroVariant3,
  macroVariant4,
  more,
  overviewPage,
  page,
  panView,
  pinInsertNav,
  plugNav,
  plusOutline,
  potentialNav,
  potetialTree,
  radiusmark,
  remove,
  structureAnd,
  structureDbis,
  structureDbplus,
  structureIs,
  structurePlus,
  structureUser,
  symbolLibEnterprise,
  symbolLibPlatform,
  tablePage,
  terminalNav,
  topologyPage,
  treePlug,
  treePotential,
  treeTerminal,
  undocked,
} as Record<string, string>
